// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hy-page-content{position:absolute;width:100%;text-align:center;margin-top:100px}
`, "",{"version":3,"sources":["webpack://./src/components/pages/index.scss"],"names":[],"mappings":"AAEA,iBACI,iBAAkB,CAClB,UAAW,CACX,iBAAkB,CAClB,gBAAiB","sourcesContent":["@import '../../scss/variables';\n\n.hy-page-content {\n    position: absolute;\n    width: 100%;\n    text-align: center;\n    margin-top: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
